import clsx from "clsx";
import { Group } from "react-resizable-panels";
import type { ChildrenProps, ClassNameProps } from "../types";
import { PanelsContext, usePanelContext } from "./context";
import { Panel } from "./panel";

/** Props Interface */
interface PanelsProps extends ChildrenProps, ClassNameProps {
	resizable?: boolean;
}

function Panels({ children, className, resizable }: PanelsProps) {
	/** Render */
	return (
		<PanelsContext.Provider value={{ resizable }}>
			<Group className={clsx("flex md:flex-row flex-col flex-1 gap-4 h-full", className)}>
				{children}
			</Group>
		</PanelsContext.Provider>
	);
}

Panels.Panel = Panel;
Panels.useContext = usePanelContext;

export { Panels };
